import { getErrorPayload } from '@application/common/helpers/api-helper';
import HourRoutingApi from '@infrastructure/hour-routing-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getHourTypesAsync = createAsyncThunk('hourRouting/getHourTypes', async (_, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.getHourTypes();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateHourTypeDisplayNameAsync = createAsyncThunk('hourRouting/updateHourTypeDisplayName', async ({ id, request }, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.updateHourTypeDisplayName(id, request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInternalDepartmentsAsync = createAsyncThunk('hourRouting/getInternalDepartments', async (_, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.getInternalDepartments();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateInternalDepartmentAsync = createAsyncThunk('hourRouting/updateInternalDepartment', async ({ id, request }, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.updateInternalDepartment(id, request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getProjectTaskMappingsAsync = createAsyncThunk('hourRouting/getProjectTaskMappings', async (query, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.getProjectTaskMappings(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createProjectTaskMappingAsync = createAsyncThunk('hourRouting/createProjectTaskMapping', async (request, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.createProjectTaskMapping(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInternalDepartmentMembershipsAsync = createAsyncThunk('hourRouting/getInternalDepartmentMemberships', async (freelancerId, { rejectWithValue }) => {
    try {
        const response = await HourRoutingApi.getInternalDepartmentMemberships(freelancerId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInternalBookingPermissionsAsync = createAsyncThunk('hourRouting/getInternalBookingPermissions', async (freelancerId, { rejectWithValue }) => {
    try {
        return (await HourRoutingApi.getInternalBookingPermissions(freelancerId)).data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createInternalBookingPermissionAsync = createAsyncThunk('hourRouting/createInternalBookingPermission', async (request, { rejectWithValue }) => {
    try {
        return (await HourRoutingApi.createInternalBookingPermission(request)).data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const endInternalBookingPermissionAsync = createAsyncThunk('hourRouting/endInternalBookingPermission', async ({ id, request }, { rejectWithValue }) => {
    try {
        return (await HourRoutingApi.endInternalBookingPermission(id, request)).data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
